import React from 'react';

const statuses = {
    'CAPTURED': {
        text: 'Capturado',
        color: 'success'
    },
    'PAYMENT_SUCCESSFUL': {
        text: 'Capturado',
        color: 'success'
    },
    'AUTHORIZED': {
        text: 'Autorizado',
        color: 'info'
    },
    'PAYMENT_UNAUTHORIZED': {
        text: 'Não Autorizado',
        color: 'danger'
    },
    'SCAM_PREVENTOR_REJECTED': {
        text: 'Cancelado',
        color: 'danger'
    },
    'SCAM_PREVENTOR_APPROVED': {
        text: 'Em Análise',
        color: 'warning'
    },
    'FINANCIAL_ANALYSIS': {
        text: 'Em Análise',
        color: 'warning'
    },
    'IN_ANALYSIS': {
        text: 'Em Análise',
        color: 'warning'
    },
    'CANCELLED': {
        text: 'Cancelado',
        color: 'danger'
    },
    'WAITING_BANKSLIP_PAYMENT': {
        text: 'Aguardando Confirmação',
        color: 'info'
    },
    'UNKNOW': {
        text: 'Desconhecido',
        color: 'warning'
    }
};

const PaymentStatusBadge = ({ status }) => {
    const st = statuses[status] || statuses['UNKNOW'];
    return (
        <span className={`badge badge-${st.color} mr-4`}>{st.text}</span>
    );
}

export default PaymentStatusBadge;



// WEBPACK FOOTER //
// ./src/components/Shared/PaymentStatusBadge.js